import axios from 'axios'
import {
  MessageBox,
  Message
} from 'element-ui'
import store from '@/store'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true,  // 跨域请求时发送cookie
  // timeout: 5000 ,
})
// 请求拦截
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data
    if (response.data.code == undefined) {
      return response
    }
    if (res.code != 200) {
        Message({
          message: res.message,
          type: 'error',
          duration: 2 * 1000
        })
        return res;
    } else {
      return res;
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
